import React from 'react';
import PropTypes from 'prop-types';
import { urls as urlHelpers } from '../helpers';

const Ticket = ({ number }) =>
  <span key={number}>
    <a href={`${urlHelpers.JIRA_BASE_URL}/browse/${number}`} target="_blank">{number} </a>
  </span>;

Ticket.propTypes = { number: PropTypes.string };

const AnnotationsJiraTicketComponent = ({ jiraTickets }) => {
  return (
    jiraTickets && jiraTickets.length > 0 ?
      <div>
        <h4>
          JIRA Tickets: {jiraTickets.map((t, i) => <Ticket key={i} number={t} />)}
        </h4>
      </div> : null
  );
};

AnnotationsJiraTicketComponent.propTypes =
  { jiraTickets: PropTypes.array };

export default AnnotationsJiraTicketComponent;


// WEBPACK FOOTER //
// src/Components/AnnotationsJiraTicketComponent.jsx